import { useState, useEffect } from "react";
import { fetchInstallmentGroups } from "../api/requests/payment-requests";

export const useCariGroups = (isOpen, companyId) => {
    const [cariGroups, setCariGroups] = useState([]);
    const [loadingGroups, setLoadingGroups] = useState(true);
    const [error, setError] = useState("");

    const fetchGroups = async () => {
        if (!companyId) return;

        setLoadingGroups(true);
        setError("");
        try {
            const response = await fetchInstallmentGroups();
            const result = await response.json();
            if (!response.ok)
                throw new Error(result.message || "Cari/Bayi grup sorgusu başarısız.");
            setCariGroups(result.data || []);
        } catch (err) {
            setError("Taksit grubu verisi alınamadı");
        } finally {
            setLoadingGroups(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            fetchGroups();
        } else {
            // Clear data on close
            setCariGroups([]);
            setLoadingGroups(true);
        }
    }, [isOpen, companyId]); // Dependencies

    return { cariGroups, loadingGroups, error, refetchGroups: fetchGroups };
};